import { useContext, useEffect } from 'react';
import { AngularContext } from 'react-app';
import t from 'react-translate';
import prodPathReplace from 'shared/prod-path-rewrite';
import { config } from '@config/pendo.config.json';

// Styles
import { css } from '@emotion/react';
import { heatwave, novoEdBlue } from 'athena/styles/colors';
import { halfSpacing } from 'styles/global_defaults/scaffolding';

// Components
import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';

import { FirstSeenKey } from 'athena/components/constants';
import { slideInAnimation } from './reflection-workspace-container/styles';

const bannerStyles = css`
  border-radius: ${halfSpacing}px;
  background: white url(${prodPathReplace('images/program-reflection-rectangle.svg')}) no-repeat left / auto 100%;

  .icon-container {
    z-index: 1;
    i {
      color: ${heatwave};
    }
  }

  &:hover {
    .title, .action-icon-container {
      color: ${novoEdBlue};
    }
  }
`;

const ProgramReflectionBanner = () => {
  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);
  const hasSeenAnimation = localStorage.getItem(FirstSeenKey.HAS_SEEN_REFLECTION_BANNER_ANIMATION);

  const translationBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.REFLECTION_WORKSPACE.BANNER;
  const dataQa = config.pendo.athena.mentorshipProgram.participantHome.programReflections.banner;

  useEffect(() => {
    if (!hasSeenAnimation) {
      setTimeout(() => {
        localStorage.setItem(FirstSeenKey.HAS_SEEN_REFLECTION_BANNER_ANIMATION, 'true');
      }, 1000);
    }
  }, [hasSeenAnimation]);

  return (
    <ClickableContainer
      className='d-flex align-items-center p-4 position-relative overflow-hidden'
      css={[bannerStyles, !hasSeenAnimation && slideInAnimation]}
      onClick={() => {
        $state.go($state.current, { showReflections: true }, { notify: false });
      }}
      data-qa={dataQa}
    >
      <div className='icon-container p-2 mr-2'>
        <NvIcon icon='learning-catalog' size='small' />
      </div>
      <div className='flex-grow-1 pr-2'>
        <div className='title heading-4'>
          {translationBase.TITLE()}
        </div>
        <div className='description text gray-2'>
          {translationBase.DESCRIPTION()}
        </div>
      </div>
      <div className='action-icon-container'>
        <NvIcon icon='expand' size='small' />
      </div>
    </ClickableContainer>
  );
};

export default ProgramReflectionBanner;
